import styled from "styled-components";

export const Text = styled.div`
  margin-bottom: 24px;
  width: 450px;

  p {
    margin: 0 0 8px 0;
    font-size: 14px;
    line-height: 1.5;

    strong {
      color: var(--black);
      font-weight: 600;
    }
  }
`;
